import { useTranslation } from "react-i18next";
import { RowInfo, NubsUpload } from "../../common";
import MediaSectionModal from "../modals/MediaSectionModal";
import { useDeleteNubMutation } from "../Nubs.state";
import { MediaForm } from "./MediaSection.style";

const MediaSection = ({ useQuery, id }) => {
    const { t } = useTranslation();

    return (
        <RowInfo colClassName="mb-4" help={<MediaSectionModal />} isFull>
            <MediaForm id={`form-${id}`} onSubmit={e => e.preventDefault()}>
                <NubsUpload 
                    label={t(`Challenge Description`)} 
                    useQuery={useQuery} 
                    useDeleteNubMutation={useDeleteNubMutation}
                    taskId={id}
                />
            </MediaForm>
        </RowInfo>
    );
};

export default MediaSection;